import React, { forwardRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './date-range.css';
import dayjs from 'dayjs';
import { CalenderActions } from './CalenderData';
import { CalenderDatesAtom, CalenderVaidationAtom, SelectedDateAtom } from './CalenderAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
// import 'react-datepicker/dist/react-datepicker.css';
import { DatePicker } from '@mui/x-date-pickers';
// import DatePicker from 'react-datepicker';
const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
  <span className="example-custom-input" onClick={onClick} ref={ref}>
    {/* <BsFillCalendarDateFill /> */}
    <span sx={{ marginLeft: '5px' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-calendar-event"
        viewBox="0 0 16 16"
      >
        <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
      </svg>
    </span>
  </span>
));
export default function DateFilter(props) {
  const CalederAction = CalenderActions();
  const customCalenderDates = useRecoilValue(CalenderDatesAtom);
  const selectedDateArray = useRecoilValue(SelectedDateAtom);
  const [CalenderVaidations, setCalenderVaidations] = useRecoilState(CalenderVaidationAtom);
  const [selectedDate, setSelectedDate] = React.useState([new Date(), new Date()]);

  const [dateRange, setDateRange] = React.useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;

  const [timeBtns, setTimeBtns] = React.useState([
    { name: 'Days', class: 'time-btn active-btn', count: 0 },
    { name: 'Week', class: 'time-btn', count: 7 },
    { name: 'Month', class: 'time-btn', count: 30 },
  ]);
  const [DateArrayList, setDateArrayList] = React.useState(customCalenderDates);
  let dateArr = [];
  function handleDateChange(date) {
    setDateRange(date);
    dateArr[0] = date[0];
    dateArr[1] = date[1];
    setSelectedDate(dateArr);
    setCalenderVaidations({
      ...CalenderVaidations,
      selectDatePicker: true,
      selectDateSlider: false,
    });
    CalederAction.getSelectedDateArray(dateArr[0], dateArr[1]);
    let temp = CalederAction.createFromStartDate(date[0]);
    setDateArrayList(temp);
  }

  const getPreviousDate = (time) => {
    let now = dayjs();

    let previous = new Date();
    dateArr[0] = previous.setDate(previous.getDate() - time.count);
    // dateArr[0] = now.subtract(time.count, 'day').toDate();
    dateArr[1] = time.count === 0 ? undefined : new Date();
    setSelectedDate(dateArr);
    let updateTime = timeBtns.map((x) =>
      x.name === time.name ? { ...x, class: 'time-btn active-btn' } : { ...x, class: 'time-btn' }
    );
    setTimeBtns(updateTime);
    setCalenderVaidations({
      ...CalenderVaidations,
      selectDatePicker: true,
      selectDateSlider: false,
    });
    let temp = CalederAction.GetPreviousDates(24);
    setDateArrayList(temp);
    CalederAction.getSelectedDateArray(dateArr[0], dateArr[1]);
  };

  function oneDayPreviousDate(arr) {
    let temp = CalederAction.GetOneDayPreviousDate(arr);
    setDateArrayList(temp);
  }

  function oneDayNextDate(arr) {
    if (dayjs(arr[0]).format('DD/MM/YYYY') === dayjs(new Date()).format('DD/MM/YYYY')) {
      return 0;
    }
    let temp = CalederAction.GetOneDayNextDate(arr);
    setDateArrayList(temp);
  }

  function getClassName(date) {
    return !selectedDateArray.includes(dayjs(date).format('DD/MM/YYYY'));
  }

  React.useEffect(() => {
    let temp = CalederAction.GetPreviousDates(24);
    setDateArrayList(temp);
    CalederAction.getSelectedDateArray(new Date());
  }, []);

  props.onDateChange(selectedDate);

  return (
    <>
      <div className="dateFilter-wrapper">
        <h4>
          <b>Date Filter</b>
        </h4>
        <div className="dateFilter">
          <Row className="main-content align-items-center d-flex flex-row ">
            <Col sm={6} className="w-40">
              <div className="calander d-flex ">
                {/* <DateRangePickerCommon
                  handleDateChange={handleDateChange}
                  startDate={startDate}
                  endDate={endDate}
                /> */}
                <DatePicker
                  // showIcon
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    handleDateChange(update);
                  }}
                  isClearable={false}
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  maxDate={new Date()}
                  customInput={<ExampleCustomInput />}
                />
                {CalenderVaidations.selectDatePicker && (
                  <div className="calander-date ms-3">
                    {dayjs(selectedDate[0]).format('DD/MM/YYYY')} -{' '}
                    {dayjs(selectedDate[1]).format('DD/MM/YYYY')}
                  </div>
                )}
                {CalenderVaidations.selectDateSlider && (
                  <div className="calander-date ms-3">{selectedDateArray[0]}</div>
                )}
              </div>
            </Col>

            <Col sm={6} className="w-60">
              <div className="date-btn-right">
                {timeBtns.map((item, index) => {
                  return (
                    <span
                      key={index}
                      sm={3}
                      className={item.class}
                      onClick={(e) => {
                        getPreviousDate(item);
                      }}
                    >
                      <p>{item.name}</p>
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="multi-date-calender d-flex justify-content-between">
        <div className="innner-calender d-flex ">
          {DateArrayList.map((item, index) => {
            return (
              <div
                className={
                  getClassName(DateArrayList[index]) ? 'date-content' : 'date-content active-border'
                }
                key={index}
                onClick={(e) => {
                  CalederAction.getSelectedDateArray(DateArrayList[index]);
                  setCalenderVaidations({
                    ...CalenderVaidations,
                    selectDatePicker: false,
                    selectDateSlider: true,
                  });
                }}
              >
                {dayjs(DateArrayList[index]).format('ddd')}
                <div className="pt-2">{dayjs(DateArrayList[index]).format('D')}</div>
              </div>
            );
          })}
        </div>
        <div className="date-content-btn ">
          <button
            onClick={(e) => {
              oneDayPreviousDate(DateArrayList);
            }}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                />
              </svg>
            </span>
          </button>
          <div className="pt-2">
            <button
              onClick={(e) => {
                oneDayNextDate(DateArrayList);
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
